<template>
  <div class="d-flex flex-column align-items-center">
    <div class="icon-wrapper flex-center">
      <div class="icon-container flex-center">
        <i class="lock-icon"></i>
      </div>
    </div>
    <div class="header text-extra-large bold">
      As a guest in this team, you will not be able to access to this page.
    </div>
  </div>
</template>

<script>
/**
 * This component shows vision's No access message to guest users
 */
export default {
  name: 'VisionPermissionDenied',
  props: [],
  components: {},
  data() {
    return {}
  },
  computed: {},
  methods: {},
  mounted() {}
}
</script>

<style lang="scss" scoped>
@import '~@/styles/_styleConfigurations.scss';

.icon-wrapper {
  @include dimension(100px, 100px);
  border-radius: 50%;
  background: $documentColor;
}

.icon-container {
  @include dimension(70px, 70px);
  background-color: $activeQuaternary;
  border-radius: 50%;
}

.lock-icon {
  @include dimension(30px, 30px);
}
.header {
  width: 330px;
  text-align: center;
}
</style>
